const ApiPaths = {
  BINDING_INFO: '/v2/agreement/binding/',
  BINDING_STATUS: '/v2/agreement/query_binding',
  SEND_OTP: '/v2/auth/send_otp',
  VERIFY_OTP: '/v2/auth/verify_otp',
  CONFIRM_BINDING: '/v2/agreement/confirm',
};

const OauthAPIPath = '/oauthbe/api/v1/bindings/'

const OauthAdsAPIPath = '/oauthbe/api/v1/ads/'
const TrackingEventUrls = {
  sandbox: 'https://zlpdev-onlpm-log-service.zalopay.vn/tracking/event',
  staging: 'https://socialstg.zalopay.vn/v2/tracking/event',
  production: 'https://tracking.zalopay.vn/v2/tracking/event',
};

const EventTrackingList = {
  specialLandingPage: {
    id: '1599',
    eventId: {
      clientRequest: '1599.000',
      ABclientRequest: '1599.000',
      renderUIComplete: '1599.001',
      clickButtonOpenApp: '1599.002',
      autoRedirectApp: '1599.003',
      timeoutRedirectToZPI: '1599.004',
      ABrenderUIComplete: '1599.005',
      clickButtonOpenZaloPayApp: '1599.006',
      ABclickButtonOpenZaloPayApp: '1599.006',
      ABclickButtonOpenApp: '1599.007',
      ABautoRedirectApp: '1599.008',
      ABtimeoutRedirectToZPI: '1599.009',
    }
  },
  normalLandingPage: {
    id: '1598',
    eventId: {
      // New tracking
      loadedMiddlePage1Success: '1598.000',
      autoInvoke: '1598.001',
      clickOpenH5New: '1598.004',
      clickOpenZalo: '1598.003',
      clientOpenZalopay: '1598.002',
      loadedMiddlePage2Success: '1598.008',

      // Old tracking
      clientRequest: '1599.000',
      renderUIComplete: '1598.001',
      clickButtonOpenAppZaloPay: '1598.002',
      clickButtonOpenAppZalo: '1598.003',
      clickOpenH5: '1598.004',
      downloadZalo: '1598.005',
      downloadZaloPay: '1598.006',
      openZMP: '1598.007',
    }
  }
}

export {
  ApiPaths,
  OauthAPIPath,
  TrackingEventUrls,
  EventTrackingList,
  OauthAdsAPIPath
};
